import React, { Component } from 'react';
import { array, bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm, Field } from 'react-final-form';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';

import {
  FieldTextInput,
  Form,
  EditListingWizardButtons,
  TextEditor
} from '../../components';
import { maxLength, required, composeValidators } from '../../util/validators';
import arrayMutators from 'final-form-arrays';

import { getListingValuesBeforeUpdate } from '../../containers/EditListingPage/utils';

import css from './EditListingStartupOfferDescriptionForm.module.css';

const TITLE_MAX_LENGTH = 60;

export class EditListingStartupOfferDescriptionForm extends Component {
  constructor(props) {
    super(props);

    this.isMobSaf = false;
  }

  render() {
    return (
      <FinalForm
        {...this.props}
        mutators={{ ...arrayMutators }}
        initialValues={{
          ...this.props.initialValues,
        }}
        render={formRenderProps => {
          const {
            className,
            fetchErrors,
            handleSubmit,
            intl,
            disabled,
            ready,
            saveActionMsg,
            updated,
            updateInProgress,
            isClient,
            form,
            form: {
              mutators: { push },
            },
            values,
            listing,
            currentUser,
            isDraftListing,
            onHandlePreviewPopup,
            onHandleCreateAndBublishListing,
            isNewListingFlow,

            onHandleValidatonPopup,
            publishSuccess,
            startupOfferDescription,
          } = formRenderProps;

          const titleRequiredMessage = intl.formatMessage({
            id: 'EditListingOfferDescriptionForm.titleRequired',
          });
          const maxLengthMessage = intl.formatMessage(
            { id: 'EditListingOfferDescriptionForm.maxLength' },
            {
              maxLength: TITLE_MAX_LENGTH,
            }
          );
          const maxLength60Message = maxLength(maxLengthMessage, TITLE_MAX_LENGTH);

          const descriptionMessage = intl.formatMessage({
            id: 'EditListingStartupOfferDescriptionForm.startupOfferDescription',
          });
          const descriptionPlaceholderMessage = intl.formatMessage({
            id: 'EditListingOfferDescriptionForm.descriptionPlaceholder',
          });
          const descriptionRequiredMessage = intl.formatMessage({
            id: 'EditListingOfferDescriptionForm.descriptionRequired',
          });

          const { showListingsError, updateListingError, createListingDraftError } =
            fetchErrors || {};


          // NOTE: These error messages are here since Photos panel is the last visible panel
          // before creating a new listing. If that order is changed, these should be changed too.
          // Create and show listing errors are shown above submit button

          // This error happens only on first tab (of EditListingWizard)

          const errorMessageUpdateListing = updateListingError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingDescriptionForm.updateFailed" />
            </p>
          ) : null;

          const errorMessageCreateListingDraft = createListingDraftError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingDescriptionForm.createListingDraftError" />
            </p>
          ) : null;

          const errorMessageShowListing = showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingDescriptionForm.showListingFailed" />
            </p>
          ) : null;

          const submitReady = updated || ready;
          const submitInProgress = updateInProgress;
          const submitDisabled = disabled || submitInProgress || ready;

          const classes = classNames(css.root, className);
          const publicData = listing?.attributes?.publicData;

          const titleField = (
            <FieldTextInput
              id="startupOfferTitle"
              name="startupOfferTitle"
              className={css.title}
              type="text"
              label={intl.formatMessage({
                id: 'EditListingStartupOfferDescriptionForm.startupOfferTitle',
              })}
              placeholder={intl.formatMessage({
                id: 'EditListingStartupOfferDescriptionForm.namePlaceholder',
              })}
              maxLength={TITLE_MAX_LENGTH}
              validate={composeValidators(required(titleRequiredMessage), maxLength60Message)}
              isRequired
            />
          );

          const rewardField = (
            <FieldTextInput
              id="startupReward"
              name="startupReward"
              className={css.infoField}
              type="text"
              label={intl.formatMessage({
                id: 'EditListingStartupOfferDescriptionForm.startupReward',
              })}
              // placeholder={'wwww.example.com'}
              validate={!isClient && composeValidators(required('You need to complete this field'))}
              isRequired={!isClient}
            />
          );

          const descriptionField = (
            <Field
              id="startupOfferDescription"
              name="startupOfferDescription"
              label={descriptionMessage}
              placeholder={descriptionPlaceholderMessage}
              component={TextEditor}
              fieldValue={startupOfferDescription}
              isRequired
            />
          );

          let formFields = [
            titleField,
            rewardField,
            descriptionField,
          ]

          const invalidValues = getListingValuesBeforeUpdate(currentUser, [], values, isClient, false, true);

          return (
            <Form className={classes} onSubmit={handleSubmit}>
              {errorMessageCreateListingDraft}
              {errorMessageUpdateListing}
              {errorMessageShowListing}

              {formFields}

              <EditListingWizardButtons
                inProgress={submitInProgress}
                disabled={submitDisabled}
                ready={submitReady}
                saveActionMsg={saveActionMsg}
                isClient={isClient}
                isNewListingFlow={isNewListingFlow}
                isDraftListing={isDraftListing}
                onHandlePreviewPopup={onHandlePreviewPopup}
                listingData={{ values, isDescriptionTab: false }}
                listing={listing}
                values={values}
                invalidValues={invalidValues}
                onHandleCreateAndBublishListing={onHandleCreateAndBublishListing}
                onHandleValidatonPopup={onHandleValidatonPopup}
                publishSuccess={publishSuccess}
                isStartupOffer
              />
            </Form>
          );
        }}
      />
    );
  }
}

EditListingStartupOfferDescriptionForm.defaultProps = { fetchErrors: null, images: [] };

EditListingStartupOfferDescriptionForm.propTypes = {
  fetchErrors: shape({
    publishListingError: propTypes.error,
    showListingsError: propTypes.error,
    uploadImageError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  images: array,
  intl: intlShape.isRequired,
  onImageUpload: func.isRequired,
  onUpdateImageOrder: func.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  onRemoveImage: func.isRequired,
};

export default compose(injectIntl)(EditListingStartupOfferDescriptionForm);
